import React,{ Component } from 'react';
import {Link} from 'react-router-dom'
import Navigation from '../../components/navigation'
export default class equipment extends Component {
    state = {
        title:[],
    }
    componentWillMount(){
        this.setState({title:[
            '高贵的决斗艺术，这些运动装备不能少',
            '怎样穿好击剑鞋？',
            '剑戳在身上疼不疼？好的击剑服堪比防弹衣',
            '“好剑在手，天下我有”',
            '击剑手套臭了怎么办？',
            '为什么击剑不用透明的面罩？'
        ]})   
    }
    render(){
        return (
            <main>
                <Navigation tab="equipment"></Navigation>
                <div className="detail_title"> <Link to="/equipment">器材</Link> / {this.state.title[this.props.match.params.id-1]}</div>
                <div className="info_detail">
                    {this.props.match.params.id == 1 &&
                        <div className="leftInner">
                            <p>{this.state.title[this.props.match.params.id-1]}</p>
                            <p>击剑运动的灵感来源于远古时期，那时候人们用剑作为武器，用于打猎、防身之用；现代的击剑产生于17世纪左右，为了满足人们喜爱决斗的习惯，又不至于伤及身体；文雅而富有激情的击剑运动就诞生了，结合优雅的动作、灵活的战术、高超的技巧和运动员本身的敏捷性。</p>
                            <img src={require('./../../pic/equipment_01.jpg')}></img>
                            <p>早期的击剑运动与骑马、游泳、围棋等共同被列为骑士的高雅运动；现代的击剑运动作为奥运会的传统项目，分为重剑、佩剑、花剑三种，被广大人民所喜爱，随着经济条件的进步，击剑运动越来越正规化，对于比赛也有了装备服装上的严格要求。一起来看看这些专业的击剑装备吧。</p>
                            <p>—①— 击剑服</p>
                            <img src={require('./../../pic/equipment_02.jpg')}></img>
                            <p>在击剑运动形成初期，除了剑以外，没有任何的防护装备的设定；由于击剑运动具有一定的危险性，时常会出现在运动中受伤甚至丧命的情况；经过不断的发展与改革，不仅对剑做了改动，更制作了专业的击剑运动服，有效地防止运动员失手受伤。</p>
                            <p>—②— 击剑护面</p>
                            <img src={require('./../../pic/equipment_03.jpg')}></img>
                            <p>现代的击剑运动，为了进一步保障运动员的安全，将原本锋利的剑身改为更细、有弹性且较钝的剑体，而正是由于这一改革，导致了运动员们击剑时容易不慎戳伤脸部、眼镜等关键部位；专业的击剑护面就是帮助运动员解决这一问题的。</p>
                            <p>—③— 击剑手套</p>
                            <img src={require('./../../pic/equipment_04.jpg')}></img>
                            <p>击剑是一项以手持剑进行切磋剑艺的运动，早期的击剑运动中没有手套的设计，因为长时间的持剑，不仅加速了手部的疲劳感，容易失手，更不利于击剑时完全准确的剑锋走向；手套的设计可以增加手掌与剑柄的摩擦力，帮助运动更好地进行。</p>
                            <p>—④— 击剑鞋</p>
                            <p>虽然击剑运动是一项以手部为主的项目，但是对于鞋子的要求仍然不可忽视；在早期人们穿着普通鞋子击剑时，时常会因为频繁的脚步移动，躲避对手的剑锋而不慎摔倒；专业的击剑运动鞋具有更轻巧灵活的特性，同时也能保证脚部的抓地力，避免跌倒受伤。</p>
                        </div>
                    } 
                    {this.props.match.params.id == 2 &&
                        <div className="leftInner">
                            <p>{this.state.title[this.props.match.params.id-1]}</p>
                            <p>01 击剑鞋要穿合适吗？怎样测量脚的大小？</p>
                            <p>做为专业击剑鞋，辛苦的设计师设计的关于击剑鞋的重点：摩擦、减震、抗扭、抗歪、耐磨、包裹等，如果买大一号，功能性荡然无存！对脚的保护的初衷，也就迷失了。</p>
                            <p>当脚穿进鞋里后跟处能够轻松插入一根手指（大人的手指吧，其实也差不了太多），这个时候，这双鞋就买大了，使用中，脚会在鞋里逛，对脚的保护作用就差了，脚也会用不上力。必须换一双小一号的。</p>
                            <p>那么要买到合适的击剑鞋，就要知道孩子脚多大。我们一般测量脚是用公制尺子来测量。</p>
                            <p>我们可以用直尺量出孩子脚的长度（单位：厘米），那么鞋的号码和脚长的关系是：</p>
                            <p>欧码鞋号 = 脚长（厘米）× 2 - 10</p>
                            <p>比如24厘米，那么鞋的号码应该是38码。24.5厘米，鞋的号码是39。一般来说，买鞋超过一个号码大（长度差大约5毫米），这个鞋就不合适。要想准确，最好是量一下脚长，不能靠试穿的感觉。</p>
                            <p>很多参加全国赛的孩子家长都是抱着让孩子长见识的心态，读万卷书不如行万里路，那么在参加比赛之前家长们不仅要把比赛所需要的器材装备帮按照要求置办齐全，还要在行程规划上做好打算。</p>
                            <p>02 选择什么样的足垫？</p>
                            <p>鞋里配有足垫，为了更好的减震体验，“申动Ⅰ”在优惠期配送一双运动足垫E-TPU。这个型号的E-TPU足垫的厚度是7.8毫米，加上后跟的一个脚窝形状的设计，放用E-TPU足垫后，使得鞋内空间缩短了3mm左右，基本上相当于缩小了半个号。</p>
                            <p>“申动Ⅰ”鞋盒里有一双标准足垫，厚度3.5mm，没有脚窝，放用这个足垫的鞋才是标准鞋号。</p>
                            <p>如果使用E-TPU运动足垫还是不能有效地固定脚，这双鞋就是大了。</p>
                            <p>03 击剑鞋的日常保养？</p>
                            <p>一般不需要特别的保养。要想E-TPU足垫更好地发挥作用，在一段时间的使用后，比如10节课，可以拿出来用凉水清洗，不需要加洗涤剂，在水中按揉几下即可，挂起来阴干后即可重新使用，这样鞋里更卫生。</p>
                            <p>鞋的表面脏了可以用软布擦拭，整鞋没有必要水洗。</p>
                            <p>使用中，鞋带一定要整理好，系好，要一层一层地拉紧到合适的程度。如果鞋大小合适但是穿脱鞋都很容易的话，就是鞋带没系好，这同样会使得鞋的功能性减弱，我们常看见孩子的鞋前部鞋带松松垮垮的，那样就完全没有包裹性了。</p>
                            <p>击剑鞋穿在脚上，就要像长在脚上一样。</p>
                            <p>04 可以马上穿新鞋打比赛吗？</p>
                            <p>一般来说，剑手穿上新鞋，需要对脚下的力量有一个重新认识的过程。就像新车磨合一样。穿旧鞋能做的动作，换成穿新鞋，做出来会不同。鞋和剑道的摩擦系数不同，脚在新鞋里的固定情况还不稳定（比如鞋带要整理几次才能合适）。</p>
                            <p>在这样的情况下，穿新鞋，马上打比赛，是不好的。正确的做法是在比赛前训练中注意适应这双新鞋，一开始还不要做大的动作，而是一点一点加起来。经过一段时间的使用，脚和鞋才能真正的和谐统一，这时候，新鞋的优点才能慢慢地被发挥出来。</p>
                            <p>如果有计划更换击剑鞋，至少在比赛前两周就应该拿到鞋，并在比赛前达到一定的使用量。</p>
                            <p>05 击剑鞋可以日常穿吗？</p>
                            <p>答案是肯定的。我们在测试中，剑手穿着“申动Ⅰ”跑步、踢球、打篮球、羽毛球，一般的活动都没有问题。除了其他运动类的专业性要求（比如鞋钉），运动的需要是可以满足的。其良好的减震、支撑、包裹性，使他在各种运动中都感觉很舒服。</p>
                            <p>然而，我们又要泼一盆冷水，为了你的击剑鞋保持更长时间的功能性，最好还是专鞋专用，土豪除外，但是建议，上剑道的鞋不要在室外穿用。除了在地面上不可预知的磨损外，尘土，也会影响击剑鞋在剑道上的表现。</p>
                            <p>如果剑手在比赛中好比一台战斗的武器，好的击剑鞋是你的底座、你的行动部分。一定要得到你的爱护。</p>
                        </div>
                    } 
                    {this.props.match.params.id == 3 &&
                        <div className="leftInner">
                            <p>{this.state.title[this.props.match.params.id-1]}</p>
                            <p>24日，军运会击剑比赛就要进入尾声，重剑、花剑、佩剑三个剑种全部上场。目前，中国队取得了1金2银1铜的好成绩。长江日报-长江网记者看到各国剑客们频频上演挥剑猛刺急劈的动作，每一剑都是真的，激烈之时剑身甚至断裂。剑客们怎么能承受这么大的力量，却像美猴王初进水帘洞一样，进得去出得来又不伤身体。</p>
                            <img src={require('./../../pic/equipment31.jpg')}></img>
                            <p>男子重剑团体比赛现场 记者许魏巍 摄</p>
                            <p>武汉城市职业学院网球学院教练孙晓毅介绍，击剑服对运动员起到了很好的保护作用。根据国际剑联制定的抗压标准，符合标准的击剑服必须承受800牛顿的力。这相当于80公斤的冲击力。记者脑补了一袋80公斤的米砸过来的场景。孙教练说，好的击剑服的确堪比防弹衣。而对于如奥运会、军运会这样的高规格国际赛事，击剑服的抗压力要达到1500牛顿，这相当于150公斤的冲击力。最近网上流传一段国外的击剑服射击试验的视频，子弹击中击剑服，表面有破损，但背面却完好无损，表明子弹并未射穿防护服。</p>
                            <img src={require('./../../pic/equipment32.jpg')}></img>
                            <p>男子重剑团体比赛现场 记者许魏巍 摄</p>
                            <p>武汉城市职业学院特意为观众准备了击剑嘉年华活动区域，让观众在观赛之余还能体会击剑的乐趣。记者来到该区域，用手触摸了一位志愿者身穿的击剑防护服，感觉像薄型棉袄，看上去并没有特别之处。记者持一把花剑刺向了穿防护服的志愿者，这位志愿者表示并不疼。随后又换了一把重量更重的重剑刺向志愿者，对方表示感觉力道稍大一点，仍无明显的疼痛感。虽然说击剑服能起到很好的保护作用。但给孩子培训击剑的第一课就是讲安全，除了比赛和双人对击训练，剑是不能对着人的。孙教练表示。比赛中，重剑、花剑、佩剑选手的服装也有差异。重剑刺中的有效部位是全身，重剑选手只穿一套击剑防护服；花剑有效部分是躯干，除了防护服，还要加穿金属背心；佩剑有效部位是上半身和头部，除了击剑防护服，还要穿金属衣。</p>
                            <img src={require('./../../pic/equipment33.jpg')}></img>
                            <p>男子重剑团体比赛现场 记者许魏巍 摄</p>
                            <p>记者看到，重剑看起来最长，圆形护手盘较大，握起来更沉。而花剑、佩剑相对而言更轻。花剑也是圆形护手盘，但比重剑小。而佩剑的护手盘为月牙形。三种剑的剑身都是钢制的，硬而有弹性，剑头都是钝点。孙教练说，曾在比赛中，剑被折到90度，再被选手踩直恢复。就规则而言，重剑的规则最简单，现在作为击剑初学者学习的基础剑。因为全身都是有效部位，刺中就得分，重剑选手更为谨慎，更需要技巧和准确性。花剑、佩剑得分讲究主动权，花剑是先接触对手剑的一方拥有得分主动权，所以花剑手上动作最多。佩剑则是主动发起进攻的一方拥有得分的优先权。双方都想先发起进攻，所以佩剑速度最快。 </p>
                        </div>
                    } 
                    {this.props.match.params.id == 4 &&
                        <div className="leftInner">
                            <p>{this.state.title[this.props.match.params.id-1]}</p>
                            <p>剑阁峥嵘而崔嵬，一夫当关，万夫莫开！剑客是剑的载体，剑是剑客的灵魂！击剑作为依剑而生的一种运动，选对一把好剑才能在赛场上无往不胜！</p>
                            <p>如何挑选好剑</p>
                            <p>剑，握在手中，是赛场上冲锋陷阵的武器，是赛场上展现自我的工具！那么大家都对自己手中的剑了解多少呢？又到底该如何选择呢？</p>
                            <p>何为好剑</p>
                            <p>1、弓形合适，重心合理，剑整体轻盈;</p>
                            <p>2、剑头灵敏度高</p>
                            <p>3、剑头、导线无脱落现象</p>
                            <p>4、剑条表面光亮</p>
                            <p>5、规格符合国际标准</p>
                            <p>各种剑条是易耗品，它的使用寿命根据你的使用频率和使用方式来决定。所以，不同的使用频率和使用方式产生的损耗属于正常现象。</p>
                            <p>如何识别剑条钢材的选择与加工工艺：剑条的材料是优质弹簧钢，经过调质、淬火热处理工艺及几十道加工工艺精制而成，每一批次都要经过严格检验层序筛选才能生产出一根合格剑条。不同的生产管理和不同在加工控制决定着优质剑条的成品率。生产工艺和生产管理及检验层序的不严谨不规范会产生大量的不合格产品。优质的剑条有着合适的弓形位置和重心；良好的弹性、耐疲劳性及安全性；反之不合格的剑条在几个方面的性能就相差甚远。优质的剑条是运动员完成训练和比赛的重要保证，运动员技术动作的定型、良好剑感的形成、娴熟的技战术能力、优异的比赛成绩都和这把剑有着紧密的联系。</p>
                            <p>好剑当配英雄，那么我们该选择什么剑来配合我们的小剑客们呢？</p>
                            <p>击剑品牌的选择：每一位剑客都会有自己喜爱的击剑品牌，如何选择自己的击剑装备时我给大家几个建议：</p>
                            <p>1、选择在国际剑联认证和中国击剑协会认证的品牌。</p>
                            <p>2、选择国内国外重要赛事运动员使用频率高的击剑品牌。</p>
                            <p>3、选择合适自己而价廉物美性价比高的品牌。</p>
                            <p>4、根据各位击剑爱好者不同的训练比赛需要选择适合自己的装备。击剑运动是一项绅士的、睿智的、健康和充满激情运动，实现良好的运动体验和创造优异的比赛成绩每一位击剑爱好者的愿望。如何睿智的选择自己的击剑装备也是一件有学问的事情。 </p>
                        </div>
                    } 
                    {this.props.match.params.id == 5 &&
                        <div className="leftInner">
                            <p>{this.state.title[this.props.match.params.id-1]}</p>                           
                            <p>打开击剑包，那是什么味道？强烈的气味几乎杀了我我猜想应该是击剑手套的臭味</p>
                            <p>事实证明，这是对的不起眼的击剑手套可以隐藏一些严重的臭味当然一般我们的第一选择就是清洁这个手套那么如何清理击剑手套呢？我发现有一些解决方案是有效的快速修复方法。这些都不需要很长时间，但它们都能为您提供有用的东西！</p>
                            <p>1.抗菌喷雾。滴露是一个很好的。彻底涂抹内部，然后将其彻底风干（从太阳出来，但在一个完全干燥的地方）。</p>
                            <p>2.抗菌洗涤剂。在这种情况下，Napisan可能只是你最好的朋友。它是一种极好的抗菌肥皂，可以让你彻底清洁手套而不会伤害它。</p>
                            <p>3.小苏打。这对于没有异味的手套特别有用。将一茶匙放入干燥的手套中并放置过夜。第二天你就会发现手套的异味少了许多。</p>
                            <p>4.抗菌足粉。它有点像小苏打，你可以用使用小苏打的方法使用它，但它是为此目的而制作的。警告！- 找一个不会让你或你的孩子打喷嚏的方式！</p>
                            <p>5.冻结它。冰冻是杀死细菌的好方法。细菌需要温暖的生活环境，所以摆脱这种温暖真的可以很好地帮助你摆脱手套的气味。在你冻结之前确保手套是干的，否则你会损坏它的结构。这意味着让它完全风干，即使它只是汗水湿润。为了防止冰箱像旧袜子一样闻起来，先将手套放入密封袋中。把它留在那里至少8个小时，但24小时更好。这招很神奇！</p>
                            <p>最最最关键的来了！那就是预防！预防是真正的关键！</p>
                            <p>1.最好的方法是防止手套变臭，就是尽量避免让手套远离汗液或者臭味，这可比清洗手套更加的有效。</p>
                        </div>
                    } 
                    {this.props.match.params.id == 6 &&
                        <div className="leftInner">
                            <p>{this.state.title[this.props.match.params.id-1]}</p>
                            <p>我们现在看到的面罩都不是透明的面罩，那么为什么现在很多的赛场都不使用透明的面罩呢？</p>
                            <p>透明面罩让恐惧扑面而来。</p>
                            <p>从2002年起，国际剑联推荐使用透明面罩。其主要表面和旧面罩一样仍为金属网状，只是眼鼻部位改用了像玻璃一样透明而坚固的聚碳酸酯材料。</p>
                            <p>弊端：虽然改善了采光效果，但是非平面的透明材料容易使运动员的视觉发生偏差，而且透明部分在选手呼气时会产生雾气阻碍视线。另外，在佩剑比赛中头部属于有效部位，完全由金属网覆盖的旧面罩一旦触剑立即连通电路显示中剑。但新面罩正面的透明部分为不导电材料，所以不知不觉间加大了运动员们得分的难度。</p>
                            <p>利端：但是在国际剑联看来，透明面罩能让人们在电视转播中清楚看到运动员的面部表情，尤其是当剑刺来时那种恐惧扑面而来的效果使得运动员们比以前更人性化。而且新面罩在中剑后还会亮起前额的小灯，这样就提高了比赛的观赏性。</p>
                            <p>透明面罩引争议在近来的国内击剑赛中，中国香港、天津等队的部分队员使用了新型透明面罩，除了击中头部无效的花剑，在佩剑和重剑的实战中使用新型面罩确实占便宜。</p>
                            <p>在佩剑比赛中头部属于有效部位，旧面罩完全由金属网覆盖，一旦触剑立即连通电路、显示中剑。</p>
                            <p>但由于新面罩正面有近一半的面积是不导电的材料，透明部分中剑后不连通电路，因此使用新面罩的一方肯定占便宜。重剑因为电路设计不同，剑端击中透明部分后也会亮信号。很多队员反映：由于透明部分远比旧金属网面罩光滑，剑端触到时容易打滑而变为无效剑。</p>
                            <p>从以上几点来看大家可能就知道为什么大部分面罩是不透明的了</p>
                        </div>
                    } 
                    
                    <div className="rightInner">
                        <p>更多推荐</p>
                        <ul>
                            <Link to="/equipment/detail/1">
                            <li>
                                <img src={require('./../../pic/equipment_02.jpg')} alt=""></img>
                                <p>高贵的决斗艺术，这些运动装备不能少</p>
                            </li>
                            </Link>
                        </ul>
                    </div>
                </div>
                <div className="changePiece">
                    {this.props.match.params.id > 1 &&
                        <p><b>上一篇：</b><Link to={'/equipment/detail/'+(parseInt(this.props.match.params.id)-1)}>{this.state.title[this.props.match.params.id-2]}</Link></p>
                    }
                    {this.props.match.params.id < 6 && 
                    <p><b>下一篇：</b><Link to={'/equipment/detail/'+(parseInt(this.props.match.params.id)+1)}>{this.state.title[this.props.match.params.id]}</Link></p>
                    }
                </div>
            </main>
        )
    }
};